import { render } from "./BaseInputLittle.vue?vue&type=template&id=4d6c3e31&scoped=true"
import script from "./BaseInputLittle.vue?vue&type=script&lang=js"
export * from "./BaseInputLittle.vue?vue&type=script&lang=js"

import "./BaseInputLittle.vue?vue&type=style&index=0&id=4d6c3e31&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6c3e31"]])

export default __exports__